import { getCarById, getTrackById } from '../../content';
import type { GameController } from '../../core/GameController';
import { formatDelta, formatRaceTime } from '../../core/format';
import type { GameSnapshot } from '../../core/types';
import { ActionButton, BrandMark } from '../components/MenuFrame';

export function ResultsScreen({ controller, snapshot }: { controller: GameController; snapshot: GameSnapshot }) {
  const result = snapshot.result;
  if (!result) return null;
  const track = getTrackById(result.trackId);
  const car = getCarById(result.carId);
  return (
    <div className={`results-screen screen-layer ${result.isNewBest ? 'results-screen--record' : ''}`}>
      <div className="results-screen__rays" aria-hidden="true" />
      <section className="results-card">
        <header>
          <BrandMark />
          <p className="eyebrow">Run complete</p>
          <h1>{result.isNewBest ? 'New Personal Best' : 'Finish Recorded'}</h1>
          <div className="results-card__pairing"><span>{track.name}</span><i /> <span>{car.name}</span></div>
        </header>
        <div className="result-time">
          <small>Final time</small>
          <strong>{formatRaceTime(result.finalTimeMs)}</strong>
          {result.isNewBest && <span className="record-stamp">NEW BEST</span>}
        </div>
        <div className="result-comparison">
          <div>
            <small>Previous best</small>
            <b>{formatRaceTime(result.previousBestMs)}</b>
          </div>
          <div className={result.differenceMs !== null && result.differenceMs < 0 ? 'is-faster' : ''}>
            <small>Difference</small>
            <b>{result.previousBestMs === null ? 'FIRST RUN' : formatDelta(result.differenceMs)}</b>
          </div>
          <div>
            <small>Checkpoints</small>
            <b>{track.checkpointFractions.length} / {track.checkpointFractions.length}</b>
          </div>
        </div>
        <nav className="results-actions" aria-label="Race result actions">
          <ActionButton autoFocus variant="primary" icon="↻" label="Retry" detail="Return to the grid instantly" onClick={() => controller.retryRace()} />
          <ActionButton icon="◇" label="Change Car" onClick={() => controller.openCarSelect()} />
          <ActionButton icon="⌁" label="Change Track" onClick={() => controller.openTrackSelect()} />
          <ActionButton icon="⌂" variant="quiet" label="Main Menu" onClick={() => controller.showMainMenu()} />
        </nav>
        <footer>
          <span>Personal bests are stored locally on this device.</span>
        </footer>
      </section>
      {result.isNewBest && (
        <div className="confetti" aria-hidden="true">
          {Array.from({ length: 34 }, (_, index) => <i key={index} style={{ '--i': index } as React.CSSProperties} />)}
        </div>
      )}
    </div>
  );
}
